import PageHeader from "@/components/PageHeader";
import { Link } from "react-router-dom";
import ServicesShowcase from "@/components/ServicesShowcase";

export default function ServicesPage() {
  return (
    <>
      <PageHeader
        eyebrow="Nos services"
        title="Impression & modélisation 3D sur demande."
        sub="Conception 3D sur mesure, réparation de pièces cassées et impression 3D à la demande en PLA, PLA carbone ou PETG (autres matériaux sur demande), à l'unité ou en petite série."
        pageTitle="Services — Modélisation & impression 3D sur demande | TroiDéo"
      />
      <ServicesShowcase />
      <nav aria-label="Nos services en détail" className="mx-auto max-w-7xl px-6 pb-16 text-sm text-neutral-600 lg:px-12">
        En détail :{" "}
        <Link className="text-accent underline" to="/modelisation-3d-sur-demande">modélisation 3D sur demande</Link>
        {" · "}
        <Link className="text-accent underline" to="/impression-3d-sur-demande">impression 3D sur demande</Link>
        {" · "}
        <Link className="text-accent underline" to="/creation-stl">création de fichiers STL</Link>
      </nav>
    </>
  );
}
